import { useEffect, useRef, useState } from "react";
import { RootState } from "redux/store";
import { Card, Col, Row, Form, Button } from "react-bootstrap";
import { getStores } from "redux/slices/Stores";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { Title, CustomDropDown, Spinner } from "components";
import { generalSync } from "redux/slices/Sync";
import { showToast } from "redux/slices/Toasts";


export function GeneralSync() {
	const form = useRef(null);
	const dispatch = useAppDispatch();
	const [showMenu, setShowMenu] = useState<boolean>(false);
	const stores = useAppSelector((state: RootState) => state.stores);
	const [storeList, setStoreList] = useState<{ id: number; label: string; checked: boolean; }[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const currentStoreGroupId = useAppSelector((state: RootState) => state.global.storeGroupId);

	const [options, setOptions] = useState({
		managedStock: false,
		departments: false,
		suppliers: false,
		stockGroups: false,
	})

	useEffect(() => {
		Initialise();
	}, [])

	function Initialise() {
		dispatch(getStores({storeGroupIds: [currentStoreGroupId] }));
		cleanState();
	}

	useEffect(() => {
		const temp = [];
		for (let index = 0; index < stores.table.length; index++) {
			const element = stores.table[index];
			//@ts-ignore
			temp.push({ id: element.id, label: element.name, checked: false })
		}
		setStoreList(temp);
	}, [stores.table])

	function cleanState() {
		setOptions({
			managedStock: false,
			departments: false,
			suppliers: false,
			stockGroups: false,
		});
	}

	function handleSubmit() {
		setLoading(true);
		dispatch(generalSync({
			...options, storeIds: storeList.filter(i => i.checked).map(i => i.id)
		})).then((res) => {
			if (res.data) {
				cleanState();
			}
			
			setLoading(false);
		})
	}

	function handleChange(key: string, value: any) {
		setOptions({ ...options, [key]: value });
	}

	function handleRowSelected(key: number) {
		const temp = [...storeList];
		const element = temp.find(i => i.id === key);
		if (element) {
			element.checked = !element.checked;
		}

		setStoreList(temp);
	}

	return (
		<>
			<Title pageTitle="Sync Stores" />
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className="mb-1">
								<Col>
									<Form onSubmit={handleSubmit} ref={form}>
										<Row>
											<Col md={12}>
												<Form.Group>
													<Form.Check
														type="checkbox"
														id="stock-pricing-details"
														label="All"
														className=".custom-control-checkbox-noreverse mb-2 checkboxborder"
														checked={options.managedStock && options.departments && options.suppliers && options.stockGroups}
														onChange={(e) => setOptions({
															...options, managedStock: e.target.checked, departments: e.target.checked, suppliers: e.target.checked,
															stockGroups: e.target.checked
														})}
													/>

													<Form.Check
														type="checkbox"
														id="stock-name"
														label="Managed Stock"
														className=".custom-control-checkbox-noreverse mb-2"
														checked={options.managedStock}
														onChange={(e) => handleChange("managedStock", e.target.checked)}
													/>
													<Form.Check
														type="checkbox"
														id="stock-department"
														label="Department"
														className=".custom-control-checkbox-noreverse mb-2"
														checked={options.departments}
														onChange={(e) => handleChange("department", e.target.checked)}
													/>
													<Form.Check
														type="checkbox"
														id="stock-supplier"
														label="Supplier"
														className=".custom-control-checkbox-noreverse mb-2"
														checked={options.suppliers}
														onChange={(e) => handleChange("supplier", e.target.checked)}
													/>

													<Form.Check
														type="checkbox"
														id="stock-stockGroups"
														label="Stock Group"
														className=".custom-control-checkbox-noreverse mb-2"
														checked={options.stockGroups}
														onChange={(e) => handleChange("stockGroups", e.target.checked)}
													/>

												</Form.Group>
											</Col>
										</Row>
										<Row className="mt-3">

											<Col md={3}>
												<CustomDropDown
													items={storeList}
													handleChecked={(e) => handleRowSelected(e)}
													displayDropdown={showMenu}
													setDisplayDropdown={setShowMenu}
													className="cutom-table-checkbox-dropdown fullwidth mt-2"
													placeholder="Stores"
													selectedPlaceholder="Stores"
												/>
											</Col>

											<Col md={3}>

											</Col>

											<Col sm={6} className="d-flex flex-row-reverse">
												<Button variant="primary" className="btn m-1 cta-button" disabled={loading} onClick={handleSubmit}>
													{loading ? <><Spinner className="spinner-border-sm me-1" tag="span" color="white" /></> : <></>}
													{loading ? <>Syncing...</> : <>Sync</>}
												</Button>
											</Col>
										</Row>
									</Form>
								</Col>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	);
}